import Header from "@shared/common/Header";
import OverviewSession from "@shared/overview/OverviewSession";
import "react-datepicker/dist/react-datepicker.css";
import { useTheme } from '../../../shared/common/ThemeContext'; // Importer le hook

const SessionPage = ({ clubId }) => {
    const { isDarkMode } = useTheme(); // Récupérer le contexte

    return (
        <div className={`flex-1 overflow-auto relative z-10 ${isDarkMode ? "bg-gray-900 text-white" : "bg-gray-100 text-gray-800"}`}>
            <OverviewSession clubId={clubId} />
        </div>
    );
};

export default SessionPage;

